// Laravel JWT delete — avoids the old Zend CSRF FormData post that failed on the
// separate ">10 properties" page, and avoids a global axios CSRF interceptor.
const DELETE_CUSTOMER_PROPERTIES_URL = '/api/v2/customer/delete-customer-property';
const ADD_NEW_CUSTOMER = '/customer/add';
const EDIT_CUSTOMER = '/customer/edit';
const COUNTRIES_DATA = '/webservice/countries-data';
const GET_CUSTOMER_CONSTRAINS = '/customer/getCustomerConstrains';
const UPDATE_BOOKING_CUSTOMERS = '/customer/updateBookingCustomer';
const STORE_IMAGE_TO_TEMP_BUCKET = '/api/v2/attachments/presigned-upload-url';
const CHANGE_BOOKING_LOCATION_API = '/webservice/update-booking-location';


function buildFormData(formData, data, parentKey) {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
            buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
        });
    } else {
        const value = data == null ? '' : data;
        formData.append(parentKey, value);
    }
}

/**
 * Resolve the Laravel API base URL for admin pages.
 * Prefer window.LARAVEL_BASE (set by the layout); fall back to the local default.
 */
function resolveLaravelBase() {
    if (typeof window !== 'undefined' && window.LARAVEL_BASE) {
        return String(window.LARAVEL_BASE).replace(/\/$/, '');
    }
    if (typeof LARAVEL_BASE !== 'undefined' && LARAVEL_BASE) {
        return String(LARAVEL_BASE).replace(/\/$/, '');
    }
    return 'https://octopuspro.test:9001';
}

/**
 * Resolve the office JWT used by /api/v2 routes.
 * Laravel delete does not need a CSRF token — that is why we moved delete here
 * instead of patching every axios request with csrf_token (which spiked DB load).
 *
 * Resolution order:
 *  1. window.JWT_TOKEN (set by Zend tile layout when present)
 *  2. JWT_TOKEN script variable
 *  3. Nuxt/session payload already cached on window.__OCTOPUS_SESSION_JWT
 */
function resolveJwtToken() {
    if (typeof window !== 'undefined' && window.JWT_TOKEN) {
        return window.JWT_TOKEN;
    }
    if (typeof JWT_TOKEN !== 'undefined' && JWT_TOKEN) {
        return JWT_TOKEN;
    }
    if (typeof window !== 'undefined' && window.__OCTOPUS_SESSION_JWT) {
        return window.__OCTOPUS_SESSION_JWT;
    }
    return '';
}

/**
 * Ensure we have a JWT before calling Laravel. Some Zend pages do not embed
 * window.JWT_TOKEN; in that case, pull it once from the Nuxt session endpoint.
 */
function ensureJwtToken() {
    const existing = resolveJwtToken();
    if (existing) {
        return Promise.resolve(existing);
    }
    return window.axios
        .get('/api/nuxt/session', { params: { path_name: window.location.pathname } })
        .then(function (response) {
            const token =
                (response && response.data && response.data.JWT && response.data.JWT.token) ||
                (response && response.data && response.data.JWT) ||
                '';
            if (token && typeof token === 'string') {
                window.__OCTOPUS_SESSION_JWT = token;
                window.JWT_TOKEN = token;
                return token;
            }
            return '';
        })
        .catch(function () {
            return '';
        });
}

module.exports = {

    uploadSignature: function uploadSignature({image, customer_id, attribute_id}) {
        let image_type = 'signature';
        const formData = new FormData();
        formData.append('image', image);
        formData.append('customer_id', customer_id);
        formData.append('attribute_id', attribute_id);
        formData.append('image_type', image_type);
        formData.append('for_ajax', true);
        return ensureJwtToken().then(function (jwtToken) {
            const headers = {};
            if (jwtToken) {
                headers['Authorization'] = 'Bearer ' + jwtToken;
            }
            return window.axios.post(
                resolveLaravelBase() + STORE_IMAGE_TO_TEMP_BUCKET,
                formData,
                { headers: headers }
            );
        });
    },
    deleteCustomerProperties: function deleteCustomerProperties(toBeDeletedProperty) {
        // Call Laravel with Bearer JWT so the separate list page can delete without CSRF hacks.
        const customerPropertyId = toBeDeletedProperty && toBeDeletedProperty.customer_property_id;
        return ensureJwtToken().then(function (jwtToken) {
            const headers = {
                'Content-Type': 'application/json',
            };
            if (jwtToken) {
                headers['Authorization'] = 'Bearer ' + jwtToken;
            }
            return window.axios.post(
                resolveLaravelBase() + DELETE_CUSTOMER_PROPERTIES_URL,
                {
                    id: customerPropertyId,
                    customer_property_id: customerPropertyId,
                },
                { headers: headers }
            );
        });
    },
    addNewCustomer: function addNewCustomer(data) {
        let form = new FormData();
        buildFormData(form, data);

        return window.axios.post(ADD_NEW_CUSTOMER, form, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        });
    },
    editCustomer: function editCustomer(customerId, data) {
        let form = new FormData();
        buildFormData(form, data);

        return window.axios.post(EDIT_CUSTOMER+'/'+customerId, form, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        });
    },
    getCountriesData:function getCountriesData(params){
        return window.axios.get(COUNTRIES_DATA, {params: params});
    },
    getCustomerConstrains:function getCustomerConstrains(params){
        return window.axios.get(GET_CUSTOMER_CONSTRAINS, {params: params});
    },
    changeBookingLocationApi: function changeBookingLocationApi(customer_id,item_id,item_type){
        let form = new FormData();
        form.set('customer_id', customer_id);
        form.set('item_id', item_id);
        form.set('item_type', item_type);
        return window.axios.post(CHANGE_BOOKING_LOCATION_API, form, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        });
    },

    updateBookingCustomers: function updateBookingCustomers(bookingId,customers){
        let form = new FormData();
        form.set('customers', customers);
        form.set('booking_id', bookingId);
        return window.axios.post(UPDATE_BOOKING_CUSTOMERS, form, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        });
    }
};
